// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070613/js/" + chunkId + "." + {"44":"2c9c8adc","225":"c76d7465","481":"6e795389","486":"a5b68a35","770":"efd41c04"}[chunkId] + ".0.5374488588899597.chunk.js";
};